import { ReactComponent as SvgLifts } from 'public/assets/icons/lifts.svg';
import { ReactComponent as SvgEightPersonLifts } from 'public/assets/icons/totalLifts/eightPersonLifts.svg';
import { ReactComponent as SvgHighSpeedSixes } from 'public/assets/icons/totalLifts/highSpeedSixes.svg';
import { ReactComponent as SvgHighSpeedQuads } from 'public/assets/icons/totalLifts/highSpeedQuads.svg';
import { ReactComponent as SvgQuadChairs } from 'public/assets/icons/totalLifts/quadChairs.svg';
import { ReactComponent as SvgTripleChairs } from 'public/assets/icons/totalLifts/tripleChairs.svg';
import { ReactComponent as SvgDoubleChairs } from 'public/assets/icons/totalLifts/doubleChairs.svg';
import { ReactComponent as SvgSurfaceLifts } from 'public/assets/icons/totalLifts/surfaceLifts.svg';
import { ITerrainLifts } from '@/api/resort/types';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { MetricListItem } from '../MetricListItem';

const wrapperClass = 'mb-3 mt-8 flex items-baseline justify-between gap-2';

const headingClass = 'font-heading text-xl text-secondary md:text-2xl';
const totalClass = 'font-heading text-xl font-bold tabular-nums text-foreground md:text-2xl';

export const TotalLifts = ({
  lifts,
}: {
  lifts: ITerrainLifts,
}) => {
  const { t } = useOTSTranslation('common');
  const totalLifts = Object.values(lifts).reduce((prevValue, value) => prevValue + value, 0);

  return (
    <div id="total_lifts_widget">
      <article>
        <div className={wrapperClass}>
          <h3 className={headingClass}>{t('resort.overview.lifts')}</h3>
          <span className={totalClass}>{totalLifts}</span>
        </div>
        {!!lifts.gondolasAndTrams && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.gondolasTrams')}
            title={t('resort.overview.gondolasTrams')}
            Icon={SvgLifts}
            metric={lifts.gondolasAndTrams}
          />
        )}
        {!!lifts.eightPerson && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.eightPersonLifts')}
            title={t('resort.overview.eightPersonLifts')}
            Icon={SvgEightPersonLifts}
            metric={lifts.eightPerson}
          />
        )}
        {!!lifts.sixHS && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.highSpeedSixes')}
            title={t('resort.overview.highSpeedSixes')}
            Icon={SvgHighSpeedSixes}
            metric={lifts.sixHS}
          />
        )}
        {!!lifts.fourHS && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.highSpeedQuads')}
            title={t('resort.overview.highSpeedQuads')}
            Icon={SvgHighSpeedQuads}
            metric={lifts.fourHS}
          />
        )}
        {!!lifts.fourChairs && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.quadChairs')}
            title={t('resort.overview.quadChairs')}
            Icon={SvgQuadChairs}
            metric={lifts.fourChairs}
          />
        )}
        {!!lifts.threeChairs && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.tripleChairs')}
            title={t('resort.overview.tripleChairs')}
            Icon={SvgTripleChairs}
            metric={lifts.threeChairs}
          />
        )}
        {!!lifts.doubleChairs && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.doubleChairs')}
            title={t('resort.overview.doubleChairs')}
            Icon={SvgDoubleChairs}
            metric={lifts.doubleChairs}
          />
        )}
        {!!lifts.surface && (
          <MetricListItem
            variant="row"
            key={t('resort.overview.surfaceLifts')}
            title={t('resort.overview.surfaceLifts')}
            Icon={SvgSurfaceLifts}
            metric={lifts.surface}
          />
        )}
      </article>
    </div>
  );
};
